// extracted by css-extract-rspack-plugin
export default {"grid":"grid-kgVcac","stat":"stat-_RuCwK","value":"value-fZI_TK","ok":"ok-hg2bcv","warn":"warn-wj2u1z","danger":"danger-dXZ9sz","info":"info-UypdyN","label":"label-F22h8h"};